import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { ComponentEmptyButton } from '../shared/component-parts';
import { EditProps } from './guided-research.constants';
import GuidedResearchView from './guided-research-view';

const GuidedResearchEdit = (props: EditProps) => {
  const { openDrawer } = useActivityBuilderContext();

  return props.stimulusResourceProperties ? (
    <GuidedResearchView {...props} />
  ) : (
    <>
      <ComponentEmptyButton
        iconId="guided-research"
        onClick={() => openDrawer({ componentId: props.id })}
        buttonText="Add Guided Research"
        isSmall
      />
    </>
  );
};

export default GuidedResearchEdit;
